import React, { Component } from "react";
import {
  GET,
  POST,
  UPLOAD,
  MAX_UPLOAD_SIZE,
  Select,
  alert,
  loading,
  NavbarCustomer,
  t
} from "../../components/CustomComponent.js";
import { getProfile } from "../../utils/localStorage";

const profile = getProfile();

const PRIORITY_ICONS = [
  { match: /emergency/i, icon: "" },
  { match: /high/i, icon: "" },
  { match: /medium/i, icon: "" },
  { match: /low/i, icon: "" },
];
const DEFAULT_PRIORITY_ICON = "";

const getPriorityIcon = (item) => {
  if (item?.icon) return item.icon;
  const found = PRIORITY_ICONS.find((p) => p.match.test(item?.name_en || item?.name_th || ""));
  return found ? found.icon : DEFAULT_PRIORITY_ICON;
};

const MAX_VIDEOS = 3;
const DESC_MIN_LENGTH = 30;
const DESC_MAX_LENGTH = 500;

export default class ServiceRequestCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_super_user: profile?.user_type === "super_user",

      data_customer: [],
      assets: [],
      categories: [],
      priorities: [],
      own_customer: null,
      default_priority_id: "",

      create_customer_id: "",
      create_asset_id: "",
      create_category_id: "",
      create_service_type: null,
      create_priority_id: "",
      create_problem_desc: "",
      create_contact_name: "",
      create_contact_phone: "",
      create_preferred_date: "",
      create_preferred_time: "",

      images: [],
      videos: [],
    };
  }

  async componentDidMount() {
    loading(true);
    await this.GetOptions();

    if (this.state.is_super_user) {
      await Promise.all([this.GetCustomers(), this.GetAllAssets()]);
    } else {
      this.setState({
        create_customer_id: this.state.own_customer?.uid || "",
        create_priority_id: this.state.default_priority_id || "",
      });
      await this.GetAssets();
    }

    loading(false);
  }

  componentWillUnmount() {
    [...this.state.images, ...this.state.videos].forEach((item) => {
      if (item?.url && item.url.startsWith("blob:")) URL.revokeObjectURL(item.url);
    });
  }

  getCustomerDisplayName = (customer) => {
    const lang = localStorage.getItem("lang") || "TH";
    if (lang === "EN") {
      return `${customer?.customer_code || ""} ${customer?.full_name_en || customer?.full_name_th || "-"}`.trim();
    }
    return `${customer?.customer_code || ""} ${customer?.full_name_th || customer?.full_name_en || "-"}`.trim();
  };

  getCustomerContactName = (customer) => `${customer?.contact_first_name || ""} ${customer?.contact_last_name || ""}`.trim();

  GetOptions = async () => {
    const result = await GET("customer/work-requisitions/options");
    if (result?.status === true) {
      const own_customer = result.data?.customer || null;
      this.setState({
        categories: result.data?.categories || [],
        priorities: result.data?.priorities || [],
        own_customer,
        default_priority_id: result.data?.default_priority_id || "",
        create_contact_name: this.getCustomerContactName(own_customer),
        create_contact_phone: own_customer?.contact_phone || "",
      });
    }
  };

  GetCustomers = async () => {
    const result = await GET("admin/customers", { page: 0, page_size: 10000 });
    if (result?.status === true) {
      this.setState({
        data_customer: (result.data || []).map((c) => ({
          ...c,
          value: c.uid,
          label: this.getCustomerDisplayName(c),
        })),
      });
    }
  };

  GetAssets = async () => {
    const result = await GET("customer/assets", { page_size: 1000, page: 1 });
    if (result?.status === true) {
      this.setState({ assets: result.data?.assets || [] });
    }
  };

  GetAllAssets = async () => {
    const result = await GET("admin/assets", { page: 0, page_size: 10000 });
    if (result?.status === true) {
      this.setState({ assets: result.data || [] });
    }
  };

  getAssetOptions = () => {
    const { is_super_user, assets, create_customer_id } = this.state;
    const list = is_super_user
      ? assets.filter((a) => (a.customer?.uid || "") === create_customer_id)
      : assets;

    return list.map((a) => ({
      value: a.uid,
      label: [a.part?.name || a.name || a.asset_code, a.serial_number ? `SN: ${a.serial_number}` : null].filter(Boolean).join(" - ") || "-",
    }));
  };

  // -----------------------------------
  // File Helpers
  // -----------------------------------
  mapFilesToItems = (fileList) =>
    Array.from(fileList).map((file) => ({
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      url: URL.createObjectURL(file),
    }));

  filterValidFiles = (fileList, fileType) => {
    const max = MAX_UPLOAD_SIZE[fileType] || MAX_UPLOAD_SIZE.default;
    const arr = Array.from(fileList || []);
    const tooBig = arr.filter((f) => f.size > max);
    if (tooBig.length > 0) {
      const mb = Math.round(max / 1024 / 1024);
      alert("", "warning", t("warning"), `${t("file_too_large")} (${mb} MB): ${tooBig.map((f) => f.name).join(", ")}`);
    }
    return arr.filter((f) => f.size <= max);
  };

  handleDragOver = (e) => e.preventDefault();

  handleImageBrowse = (e) => {
    if (e.target.files?.length) {
      const newItems = this.mapFilesToItems(this.filterValidFiles(e.target.files, "image"));
      this.setState((prev) => ({ images: [...prev.images, ...newItems] }));
    }
    e.target.value = "";
  };

  handleImageDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) {
      const newItems = this.mapFilesToItems(this.filterValidFiles(e.dataTransfer.files, "image"));
      this.setState((prev) => ({ images: [...prev.images, ...newItems] }));
      e.dataTransfer.clearData();
    }
  };

  handleVideoBrowse = (e) => {
    if (e.target.files?.length) {
      const valid = this.filterValidFiles(e.target.files, "video");
      const allowed = valid.slice(0, MAX_VIDEOS - this.state.videos.length);
      const newItems = this.mapFilesToItems(allowed);
      this.setState((prev) => ({ videos: [...prev.videos, ...newItems] }));
    }
    e.target.value = "";
  };

  handleVideoDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) {
      const valid = this.filterValidFiles(e.dataTransfer.files, "video");
      const allowed = valid.slice(0, MAX_VIDEOS - this.state.videos.length);
      const newItems = this.mapFilesToItems(allowed);
      this.setState((prev) => ({ videos: [...prev.videos, ...newItems] }));
      e.dataTransfer.clearData();
    }
  };

  removeImage = (index) => {
    this.setState((prev) => {
      const images = [...prev.images];
      const [removed] = images.splice(index, 1);
      if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
      return { images };
    });
  };

  removeVideo = (index) => {
    this.setState((prev) => {
      const videos = [...prev.videos];
      const [removed] = videos.splice(index, 1);
      if (removed?.url && removed.url.startsWith("blob:")) URL.revokeObjectURL(removed.url);
      return { videos };
    });
  };

  uploadAttachments = async (items, folder, fileType) => {
    const uploaded = [];

    for (const item of items) {
      const res = await UPLOAD(item.file, { folder });

      if (res?.status === true && res?.data?.file_path) {
        uploaded.push({
          file_path: res.data.file_path,
          file_name: item.name || res.data.file_name || null,
          file_type: fileType,
          mime_type: res.data.mime_type || item.type || null,
          file_size: res.data.file_size ?? item.size ?? null,
        });
      } else {
        alert("", "warning", t("warning"), `${t("upload")} "${item?.name || ""}" ${t("fail")}`);
        return null;
      }
    }

    return uploaded;
  };

  // -----------------------------------
  // Submit
  // -----------------------------------
  handleSubmit = async () => {
    const {
      is_super_user, create_customer_id, create_asset_id, create_category_id, create_priority_id,
      create_problem_desc, create_contact_name, create_contact_phone,
      create_preferred_date, create_preferred_time,
    } = this.state;

    if (is_super_user && !create_customer_id) {
      alert("", "warning", t("warning"), t("select_customer"));
      return;
    }

    if (!create_asset_id) {
      alert("", "warning", t("warning"), t("select_asset_first"));
      return;
    }

    if (!create_category_id || !create_priority_id || !create_problem_desc || !create_contact_name || !create_contact_phone) {
      alert("", "warning", t("warning"), t("required_fields"));
      return;
    }

    const descLength = create_problem_desc.trim().length;
    if (descLength < DESC_MIN_LENGTH || descLength > DESC_MAX_LENGTH) {
      alert("", "warning", t("warning"), t("problem_description_length_invalid"));
      return;
    }

    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);

    const image_attachments = await this.uploadAttachments(this.state.images, "work-requisitions/images", "image");
    const video_attachments = await this.uploadAttachments(this.state.videos, "work-requisitions/videos", "video");

    if (image_attachments === null || video_attachments === null) {
      loading(false);
      return;
    }

    const attachments = [...image_attachments, ...video_attachments];

    const body = {
      ...(is_super_user ? { customer_id: create_customer_id } : {}),
      asset_id: create_asset_id,
      work_requisition_categories_id: create_category_id,
      work_requisition_priorities_id: create_priority_id,
      problem_description: create_problem_desc,
      contact_name_1: create_contact_name,
      contact_phone_1: create_contact_phone,
      preferred_date: create_preferred_date,
      preferred_time: create_preferred_time,
      attachments,
    };

    const result = await POST("customer/work-requisitions", body);

    loading(false);

    if (result?.status === true) {
      await alert("#", "success");
      window.location.href = "/cs/work-requests";
    } else {
      alert("", "warning", t("warning"), result?.message || t("fail"));
    }
  };

  render() {
    const {
      is_super_user, data_customer, own_customer,
      categories, priorities,
      create_customer_id, create_asset_id, create_category_id, create_service_type, create_priority_id,
      create_problem_desc, create_contact_name, create_contact_phone,
      create_preferred_date, create_preferred_time, images, videos,
    } = this.state;

    const assetOptions = this.getAssetOptions();
    const categoryOptions = categories.map((c) => ({ value: c.uid, label: c.name_th, ...c }));
    const ownCustomerOptions = own_customer ? [{ value: own_customer.uid, label: this.getCustomerDisplayName(own_customer) }] : [];

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        <div className="body p-4 mt-3" style={{ maxWidth: "900px", marginLeft: "auto", marginRight: "auto" }}>

          <div className="mb-3">
            <span
              className="text-secondary text-14 pointer"
              onClick={() => { window.location.href = "/cs/work-requests"; }}
            >
              <span className="icon me-2">{""}</span>{t("back_to_work_requests")}
            </span>
          </div>

          {/* Header */}
          <div className="rounded-4 p-4 mb-4 text-white" style={{ background: "linear-gradient(90deg, #0f766e, #14b8a6)" }}>
            <h4 className="fw-bold mb-1">{t("create_service_request")}</h4>
            <div className="text-14 opacity-75">{t("fill_details_desc")}</div>
          </div>

          {/* Section 1: Select Customer */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex align-items-center mb-3">
              <span className="wpx-32 hpx-32 rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold text-12 me-2">1</span>
              <h6 className="fw-bold text-dark mb-0">{t("select_customer")} <span className="text-danger">*</span></h6>
            </div>

            {is_super_user ? (
              <Select
                className="form-control"
                options={data_customer}
                value={create_customer_id}
                placeholder={t("select_customer")}
                onChange={(e, i) => {
                  this.setState({
                    create_customer_id: e,
                    create_priority_id: i?.priority?.uid || "",
                    create_asset_id: "",
                    create_contact_name: this.getCustomerContactName(i),
                    create_contact_phone: i?.contact_phone || "",
                  });
                }}
              />
            ) : (
              <Select
                className="form-control"
                options={ownCustomerOptions}
                value={create_customer_id}
                disabled
              />
            )}
          </div>

          {/* Section 2: Select Asset */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex align-items-center mb-3">
              <span className="wpx-32 hpx-32 rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold text-12 me-2">2</span>
              <h6 className="fw-bold text-dark mb-0">{t("select_asset")} <span className="text-danger">*</span></h6>
            </div>

            <Select
              className="form-control"
              options={assetOptions}
              value={create_asset_id}
              placeholder={t("select_asset")}
              onChange={(e) => this.setState({ create_asset_id: e })}
              disabled={is_super_user && !create_customer_id}
            />

            <div className="mt-3">
              <span className="text-success text-13 fw-bold pointer" onClick={() => alert("", "info", t("scan_qr_code"), t("coming_soon"))}>
                <span className="icon me-1">{""}</span>{t("scan_qr_code")}
              </span>
            </div>
          </div>

          {/* Section 3: Problem Description (Request Details merged in) */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex align-items-center mb-3">
              <span className="wpx-32 hpx-32 rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold text-12 me-2">3</span>
              <h6 className="fw-bold text-dark mb-0">{t("problem_description")}</h6>
            </div>

            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("req_category")} <span className="text-danger">*</span></label>
                <Select
                  className="form-control"
                  options={categoryOptions}
                  value={create_category_id}
                  placeholder={t("select_req_category")}
                  onChange={(e, i) => this.setState({ create_category_id: e, create_service_type: i?.service_type || null })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("service_type")}</label>
                <input
                  type="text"
                  className="form-control rounded-3"
                  value={create_service_type?.name_th || ""}
                  disabled
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label text-13 text-secondary">
                {t("priority_level")} <span className="badge bg-light text-secondary fw-normal ms-1 border">{t("auto_from_customer")}</span>
              </label>
              <div className="row g-2">
                {priorities.map((p) => {
                  const selected = create_priority_id === p.uid;
                  return (
                    <div key={p.uid} className="col-6 col-md-3">
                      <div
                        className="rounded-3 border p-2 text-center text-12 fw-bold"
                        style={selected
                          ? { backgroundColor: p.background_color || "#0d6efd", color: p.font_color || "#fff", borderColor: p.background_color || "#0d6efd" }
                          : { borderColor: "#e5e7eb", color: "#495057", opacity: 0.5 }}
                      >
                        <span className="icon me-1">{getPriorityIcon(p)}</span>{p.name_th}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label text-13 text-secondary">{t("detailed_description")} <span className="text-danger">*</span></label>
              <textarea
                className="form-control rounded-3"
                rows={4}
                maxLength={DESC_MAX_LENGTH}
                placeholder={t("describe_problem_placeholder")}
                value={create_problem_desc}
                onChange={(e) => this.setState({ create_problem_desc: e.target.value })}
              />
              <div className="d-flex justify-content-between text-secondary text-12 mt-1">
                <span>{t("problem_description_hint")}</span>
                <span>{create_problem_desc.length}/{DESC_MAX_LENGTH}</span>
              </div>
            </div>

            <div>
              <label className="form-label text-13 text-secondary mb-2">{t("attach_photos_documents")}</label>

              {/* Images Dropzone */}
              <label className="form-label text-13 text-secondary mb-1">{t("images")}</label>
              <div
                className="border border-dashed rounded-4 p-4 text-center bg-light mb-2"
                onDragOver={this.handleDragOver}
                onDrop={this.handleImageDrop}
              >
                <div className="text-secondary text-24 mb-2 icon">{""}</div>
                <div className="text-14 text-dark">
                  {t("drag_drop_files_here")} <label className="text-success fw-bold pointer mb-0">
                    {t("browse")}
                    <input type="file" multiple hidden onChange={this.handleImageBrowse} accept="image/*" />
                  </label>
                </div>
              </div>

              {images.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mb-3">
                  {images.map((f, idx) => (
                    <div key={idx} className="border rounded-3 p-2 text-center position-relative bg-light" style={{ width: "140px" }}>
                      <div
                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                        style={{ transform: "translate(30%, -30%)", zIndex: 2 }}
                        onClick={() => this.removeImage(idx)}
                      >
                        <span className="icon text-10">{""}</span>
                      </div>
                      <a href={f.url} target="_blank" rel="noopener noreferrer">
                        <img src={f.url} alt={f.name} className="rounded-2 mb-1" style={{ width: "100%", height: "80px", objectFit: "cover" }} />
                      </a>
                      <div className="text-10 text-secondary text-truncate" title={f.name}>{f.name}</div>
                    </div>
                  ))}
                </div>
              )}

              {/* Videos Dropzone */}
              <label className="form-label text-13 text-secondary mb-1">{t("videos_max_3")}</label>
              {videos.length < MAX_VIDEOS && (
                <div
                  className="border border-dashed rounded-4 p-4 text-center bg-light mb-2"
                  onDragOver={this.handleDragOver}
                  onDrop={this.handleVideoDrop}
                >
                  <div className="text-secondary text-24 mb-2 icon">{""}</div>
                  <div className="text-14 text-dark">
                    {t("drag_drop_files_here")} <label className="text-success fw-bold pointer mb-0">
                      {t("browse")}
                      <input type="file" multiple hidden onChange={this.handleVideoBrowse} accept="video/mp4,video/quicktime" />
                    </label>
                  </div>
                </div>
              )}

              {videos.length > 0 && (
                <div className="d-flex flex-wrap gap-2">
                  {videos.map((f, idx) => (
                    <div key={idx} className="border rounded-3 p-2 position-relative bg-light" style={{ width: "180px" }}>
                      <div
                        className="position-absolute top-0 end-0 bg-danger text-white rounded-circle wpx-15 hpx-15 d-flex align-items-center justify-content-center pointer"
                        style={{ transform: "translate(30%, -30%)", zIndex: 2 }}
                        onClick={() => this.removeVideo(idx)}
                      >
                        <span className="icon text-10">{""}</span>
                      </div>
                      <video src={f.url} controls className="rounded-2 mb-1 w-100 bg-dark" style={{ height: "100px", objectFit: "contain" }} />
                      <div className="text-10 text-secondary text-truncate" title={f.name}>{f.name}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Section 4: Contact & Schedule */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="d-flex align-items-center mb-3">
              <span className="wpx-32 hpx-32 rounded-circle bg-success text-white d-flex align-items-center justify-content-center fw-bold text-12 me-2">4</span>
              <h6 className="fw-bold text-dark mb-0">{t("contact_schedule")}</h6>
            </div>

            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("contact_person")} <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control rounded-3"
                  value={create_contact_name}
                  onChange={(e) => this.setState({ create_contact_name: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("phone_number")} <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control rounded-3"
                  value={create_contact_phone}
                  onChange={(e) => this.setState({ create_contact_phone: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("preferred_date")} </label>
                <input
                  type="date"
                  className="form-control rounded-3"
                  value={create_preferred_date}
                  onChange={(e) => this.setState({ create_preferred_date: e.target.value })}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label text-13 text-secondary">{t("preferred_time")}</label>
                <select
                  className="form-select rounded-3"
                  value={create_preferred_time}
                  onChange={(e) => this.setState({ create_preferred_time: e.target.value })}
                >
                  <option value="">{t("any_time")}</option>
                  <option value="morning">{t("morning")}</option>
                  <option value="afternoon">{t("afternoon")}</option>
                  <option value="evening">{t("evening")}</option>
                </select>
              </div>
            </div>
          </div>

          {/* Footer Actions */}
          <div className="d-flex justify-content-between align-items-center pb-4">
            <button className="btn btn-white border px-4 py-2 fw-bold rounded-3" onClick={() => { window.location.href = "/cs/work-requests"; }}>
              {t("cancel")}
            </button>
            <button className="btn btn-success px-4 py-2 fw-bold rounded-3 d-flex align-items-center" onClick={this.handleSubmit}>
              <span className="icon me-2">{""}</span>{t("submit_request")}
            </button>
          </div>

        </div>
      </div>
    );
  }
}
